import React, { Component } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import type { Dispatch } from 'redux';

import { SELECT_OPTION_STATE_KEY } from 'src/redux/constants';
import type { RootState } from 'src/redux/store';
import { selectOption } from 'src/redux/viewState/actions';

interface SelectOption {
  title: string;
  value: any;
  disabled?: boolean;
}

interface PresentationOption {
  optionIndex: number;
  title: string;
  value: any;
  disabled?: boolean;
}

interface ReactSelectOption {
  value: number;
  label: string;
  isDisabled?: boolean;
}

interface SyntheticChangeEvent {
  target: { value: number };
}

interface ContainerProps {
  id: string;
  options: SelectOption[];
  value?: any;
  dispatchSelect: (selectBoxID: string, value: any) => void;
}

export class SelectBoxContainer extends Component<ContainerProps> {
  onChange = (event: SyntheticChangeEvent) => {
    this.handleSelection(event.target.value);
  };

  handleSelection = (selectedOptionIndex: number | string) => {
    this.props.dispatchSelect(
      this.props.id,
      this.props.options[Number(selectedOptionIndex)].value,
    );
  };

  buildSelectOptionProps = (): PresentationOption[] => {
    const presentationData: PresentationOption[] = [];
    for (let i = 0, len = this.props.options.length; i < len; i++) {
      const data = this.props.options[i];
      presentationData.push({
        optionIndex: i,
        title: data.title,
        value: data.value,
        disabled: data.disabled || undefined,
      });
    }
    return presentationData;
  };
  getCurrentOptionIndex = (): number | undefined => {
    for (let i = 0, len = this.props.options.length; i < len; i++) {
      if (this.props.options[i].value === this.props.value) return i;
    }
    if (this.props.options.length > 0) {
      this.handleSelection('0');
    }
    return undefined;
  };

  render() {
    return (
      <SelectBoxPresentation
        id={this.props.id}
        data={this.buildSelectOptionProps()}
        selectedOptionIndex={this.getCurrentOptionIndex()}
        onChange={this.onChange}
      />
    );
  }
}

interface PresentationProps {
  id: string;
  data: PresentationOption[];
  selectedOptionIndex?: number;
  onChange: (event: SyntheticChangeEvent) => void;
}

export class SelectBoxPresentation extends Component<PresentationProps> {
  mapDataToSelectOptions = (item: PresentationOption): ReactSelectOption => {
    const label =
      item.title.slice(0, 50) + (item.title.length > 50 ? '...' : '');
    return {
      value: item.optionIndex,
      label: label,
      isDisabled: item.disabled || false,
    };
  };

  handleSelectChange = (selectedOption: ReactSelectOption | null) => {
    if (selectedOption && this.props.onChange) {
      const syntheticEvent = {
        target: {
          value: selectedOption.value,
        },
      };
      this.props.onChange(syntheticEvent);
    }
  };

  render() {
    const options = this.props.data.map(this.mapDataToSelectOptions);
    const selectedOption = options.find(
      option => option.value === this.props.selectedOptionIndex,
    );

    return (
      <div className="form-group">
        <Select
          id={this.props.id}
          options={options}
          value={selectedOption}
          onChange={this.handleSelectChange}
          className="col-md-2"
          classNamePrefix="react-select"
        />
      </div>
    );
  }
}

export const mapStateToProps = (state: RootState, ownProps: { id: string }) => {
  let selectBoxState;
  try {
    selectBoxState =
      state.viewState[SELECT_OPTION_STATE_KEY][ownProps.id] || {};
  } catch {
    selectBoxState = {};
  }
  const newState = {
    isFetching: false,
    error: null,
    value: null,
    ...selectBoxState,
  };
  return newState;
};

export const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    dispatchSelect: (selectBoxID: string, value: any) => {
      dispatch(selectOption(selectBoxID, value));
    },
  };
};

export const SelectBox = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SelectBoxContainer);
